// project import
import dashboard from './dashboard';
import admin from './admin';
import sadmin from './sadmin';
import root from './root';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [root, dashboard, admin, sadmin]
};

export default menuItems;
